var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit, PropSync, Watch, } from 'vue-property-decorator';
import Input from 'components/Input.vue';
import IconDislike from '@/components/Icons/IconDislike.vue';
import IconTrash from '@/components/Icons/IconTrash.vue';
import IconHistory from '@/components/Icons/IconHistory.vue';
import IconBuilding from '@/components/Icons/IconBuilding.vue';
import IconSlimMenu from '@/components/Icons/IconSlimMenu.vue';
import { SearchStatus } from '@/overmind/search/state';
import { json } from 'overmind';
import SearchFilterNegativeCnpjs from './SearchFilterNegativeCnpjs.vue';
import Modal from '@/components/Modal.vue';
import Tooltip from '@/components/Tooltip.vue';
import { mixpanelTracking } from '@/services/mixpanel';
import { connect } from '@/overmind';
import IconAutoPlay from '@/components/Autoplay/icons/IconAutoPlay.vue';
import { clearAllCache } from '@/overmind/localStorage';
let SearchFilterHeader = class SearchFilterHeader extends Vue {
    constructor() {
        super(...arguments);
        this.iconOrder = true;
        this.itemSelectedOrderBy = [];
        this.orderByItems = [];
        this.itemSelected = null;
        this.negativeCnpjsSelected = [];
        this.keyAdminNegativeCnpjs = 0;
        this.showNegatedModal = false;
    }
    onOrderItems(newVal, oldVal) {
        this.orderByItems = json(newVal);
    }
    onSelectedOrderBy(newVal, oldVal) {
        this.selectedOrderBy.find(item => {
            const res = this.orderByItems.find(orderByItem => {
                return (orderByItem.queryField === item.queryField &&
                    orderByItem.value === item.value);
            });
            const existSelectedItem = this.itemSelectedOrderBy.find(i => res && i.queryField == res.queryField);
            if (!existSelectedItem && res) {
                this.itemSelected = res;
            }
        });
    }
    showSearchHistory(verify) {
        if (verify) {
            return true;
        }
        else {
            mixpanelTracking('search: Clicou em histórico de buscas salvas');
            return true;
        }
    }
    async showConsultHistory() {
        mixpanelTracking('search: Listou empresas consultadas');
        // @ts-ignore TS2349: property inexistent
        await this.actionsSearch.searches.getConsultHistory(1);
    }
    get enabledSortOption() {
        return this.failureOnLoadSearchResult;
    }
    setQuickSearchInput(term) {
        if (term && term.length > 0 && term.trim().length === 0) {
            return;
        }
        this.$emit('setQuickSearchInput', term ? term.trim() : term);
    }
    setOrderBy(value) {
        mixpanelTracking('search: Ordem do resultado foi alterada');
        this.checkItemSelected(value);
        return value;
    }
    checkItemSelected(itemSelected) {
        if (this.itemSelected == itemSelected) {
            this.itemSelected = null;
        }
        else {
            this.itemSelected = itemSelected;
        }
    }
    createSearch(companyId) {
        // If it's full of spaces, do not send the request
        if (this.genericTerm &&
            this.genericTerm.length > 0 &&
            this.genericTerm.trim().length === 0) {
            return;
        }
        const term = (this.genericTerm || '').trim();
        if (this.totalSelected !== 0 || term.length > 0) {
            mixpanelTracking('search: Gerou uma busca');
            this.$emit('createSearch', true);
        }
    }
    showAdvancedFilterModal() {
        const { searchId } = this.$route.params;
        mixpanelTracking('filtros avançados: Abriu os filtros avançados');
        //@ts-ignore
        this.actionsSearch.showAdvancedFilterModal({
            show: true,
            searchId,
            clickedBtn: true,
        });
    }
    disabledFilterAdvancedButton() {
        return this.createSearchState === SearchStatus.RECEIVING;
    }
    clearCache() {
        clearAllCache();
        mixpanelTracking('search: Limpou o cache do navegador');
    }
    openNegatedModal() {
        mixpanelTracking('search: Clicou em CNPJs Negativados');
        this.showNegatedModal = true;
    }
};
__decorate([
    Prop({ default: SearchStatus.NOT_RECEIVED })
], SearchFilterHeader.prototype, "createSearchState", void 0);
__decorate([
    Prop({ default: 0 })
], SearchFilterHeader.prototype, "totalSelected", void 0);
__decorate([
    PropSync('searchTerm', { default: '' })
], SearchFilterHeader.prototype, "genericTerm", void 0);
__decorate([
    Prop({ default: () => [] })
], SearchFilterHeader.prototype, "orderItems", void 0);
__decorate([
    Prop({ default: () => [] })
], SearchFilterHeader.prototype, "selectedOrderBy", void 0);
__decorate([
    Prop({ default: false })
], SearchFilterHeader.prototype, "failureOnLoadSearchResult", void 0);
__decorate([
    Prop({ default: false })
], SearchFilterHeader.prototype, "disableShowFilterButton", void 0);
__decorate([
    Prop({ default: false })
], SearchFilterHeader.prototype, "emptyReturn", void 0);
__decorate([
    Prop({ default: 0 })
], SearchFilterHeader.prototype, "companiesCount", void 0);
__decorate([
    Watch('orderItems', { immediate: true })
], SearchFilterHeader.prototype, "onOrderItems", null);
__decorate([
    Watch('selectedOrderBy')
], SearchFilterHeader.prototype, "onSelectedOrderBy", null);
__decorate([
    Emit('showSearchHistory')
], SearchFilterHeader.prototype, "showSearchHistory", null);
__decorate([
    Emit('setOrderBy')
], SearchFilterHeader.prototype, "setOrderBy", null);
SearchFilterHeader = __decorate([
    Component(connect(({ actions, state }) => ({
        userActions: actions.users,
        actionsSearch: actions.search,
        activeModal: state.search.activeModal,
        histories: state.search.histories,
        showAutoPlay: state.search.showAutoPlay,
    }), {
        name: 'SearchFilterHeader',
        components: {
            Input,
            Modal,
            SearchFilterNegativeCnpjs,
            IconDislike,
            IconTrash,
            IconHistory,
            IconSlimMenu,
            Tooltip,
            IconBuilding,
            IconAutoPlay,
        },
    }))
], SearchFilterHeader);
export default SearchFilterHeader;
